import Layout from '@/views/MemberLayout'

import layoutRouteConfig from './layout-route-config'

const genPath = (name, params = []) => {
  if (!params || params.length == 0) {
    return name
  }
  const paramsPath = params.map(p => `:${p}`).join('/')
  return `${name}/${paramsPath}`
}

const layoutRoutes = makeLayoutRoutes(layoutRouteConfig, Layout)


function makeLayoutRoutes(routeConfig, layoutComponent) {
  return routeConfig.map(config => ({
    path: `/${config.name}`,
    name: config.name,
    meta: config.meta,
    component: layoutComponent,
    redirect: config.redirect,
    hidden: config.hidden === true,
    children: config.children ? config.children.map(child => ({
      name: `${config.name}-${child.name}`,
      path: genPath(child.name, child.params),
      component: async () => {
        const com = await child.component()
        com.default.name = `${config.name}-${child.name}`
        return com
      },
      meta: child.meta,
      props: child.props,
      hidden: child.hidden === true
    })) : undefined
  }))
}

export const routes = [{
    name: 'land',
    path: '/land/:activityId',
    props: true,
    component: () => import('@/views/Land'),
    hidden: true
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  {
    name: 'ddcallback',
    path: '/ddcallback/:companyId',
    props: true,
    component: () => import('@/views/Login/callback/dingtalk'),
    hidden: true
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/ErrorPage/404'),
    hidden: true
  },
  {
    name: '401',
    path: '/401',
    component: () => import('@/views/ErrorPage/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    name: 'root',
    redirect: '/home',
    children: [{
      name: 'home',
      path: 'home',
      query: ['cateId', 'hasStock', 'marks', 'secondCates', 'sortPrice', 'page'],
      component: () => import('@/views/Home'),
      meta: { title: 'home', icon: 'dashboard', hideBreadcrumb: true }
    }]
  },
  { path: '*', redirect: '/404', hidden: true },
  ...layoutRoutes
]
